import { Content } from '../../types';

export const phuketContent: Content = {
  title: 'פוקט – האי הגדול והמרהיב של תאילנד',
  imageUrl: '/images/thailand/phuket/phuket-wide.jpeg',
  introduction:
    '<strong>"גלו את פוקט, האי המרהיב של תאילנד: חופים זהובים, תרבות ססגונית ואווירה שאינה נגמרת." – מדריך מקיף לשנת 2025</strong>',
  sections: [
    {
      title: 'היכרות עם פוקט – האי הגדול והמרהיב של תאילנד',
      type: 'sub-headers',
      content: [
        {
          text: '<strong>פוקט – האי הגדול והמרהיב של תאילנד – מחכה לכם עם חופים עוצרי נשימה, תרבות מרתקת, חיי לילה סוערים ואינספור אטרקציות לכל גיל.</strong>',
        },
        {
          text: 'פוקט (Phuket) הינו האי הגדול ביותר בתאילנד ואחד מיעדי התיירות הפופולריים בדרום-מזרח אסיה. הוא שוכן בים אנדמן, מערבית ליבשת ומחובר אליה באמצעות שני גשרים. בזכות החופים המרהיבים, המלונות המפוארים, מגוון האטרקציות וחיי הלילה הסוערים שבו, פוקט הפך לגן עדן אמיתי עבור תיירים מכל העולם.',
        },
        {
          text: 'האי מציע חוויות לכל סוג של מטייל: חופשת בטן-גב רגועה, טיולים בטבע עוצר נשימה, חוויות קולינריות אותנטיות, פעילויות אקסטרים, מסיבות סוערות ועוד.',
        },
      ],
    },
    {
      title: 'מזג האוויר בפוקט – מתי כדאי לבקר?',
      description:
        'מזג האוויר בפוקט חם ולח לאורך כל השנה, אך ישנם חודשים אידיאליים יותר לטיול. הכירו את עונות השנה בפוקט ותכננו את החופשה המושלמת בהתאם:',
      type: 'sub-headers',
      content: [
        {
          subtitle: 'העונה היבשה (נובמבר – אפריל)',
          text: 'התקופה המומלצת ביותר לביקור, מזג אוויר חם ושמשי כמעט בכל יום.',
        },
        {
          subtitle: 'העונה החמה (מרץ – מאי)',
          text: 'חם מאוד עם לחות גבוהה, מתאים לאוהבי מזג אוויר חם במיוחד.',
        },
        {
          subtitle: 'העונה הרטובה (יוני – אוקטובר)',
          text: 'עונת המונסונים עם גשמים עזים לפרקים, אך האי ירוק מתמיד והמחירים נוחים.',
        },
      ],
    },
    {
      title: 'אזורים מומלצים ללינה בפוקט',
      type: 'sub-headers',
      description:
        'כל מטייל ימצא את האזור המתאים לו בפוקט – מאזורי בילויים סוערים ועד פינות חמד רגועות בסמוך לים. לפניכם סקירה של האזורים המרכזיים ללינה באי:',
      content: [
        {
          subtitle: 'פטונג (Patong Beach)',
          text: 'האזור המפורסם ביותר באי, מרכז התיירות, חיי הלילה והקניות של פוקט. כאן תמצאו שפע של מלונות, מסעדות, ברים, מועדונים ומרכזי קניות גדולים. מתאים מאוד למחפשים חיי לילה תוססים ואווירה תוססת 24/7.',
        },
        {
          subtitle: 'קארון (Karon Beach)',
          text: 'חוף רחב ומרהיב עם אווירה רגועה יותר מפטונג, אך עדיין עם הרבה מסעדות, חנויות ואטרקציות בסביבה. מתאים למחפשים שילוב בין חופשת בטן - גב רגועה לבין נגישות לאקשן.',
        },
        {
          subtitle: 'קאטה (Kata Beach)',
          text: 'אזור אהוב במיוחד על משפחות, גולשים וזוגות. החוף יפהפה ונוח מאוד לרחצה, האווירה נינוחה ומבחר המלונות מצוין. מקום מעולה למחפשים רוגע בלי לוותר על נוחות ובילויים קלים.',
        },
        {
          subtitle: 'קאמלה (Kamala Beach)',
          text: 'עיירת חוף שלווה המתאימה למשפחות ולמטיילים המעדיפים חופשה רגועה ורגועה יותר. בקאמלה תמצאו גם את פארק המופעים "פנטסי פוקט" (FantaSea Phuket) ושווקי לילה מקומיים.',
        },
        {
          subtitle: 'סורין (Surin Beach)',
          text: 'אזור יוקרתי עם ריזורטים מהודרים, וילות פרטיות ומסעדות גורמה. מתאים מאוד לזוגות בירח דבש או למחפשים חוויית נופש ברמה גבוהה לצד חוף יפהפה ומים צלולים.',
        },
        {
          subtitle: 'בנג טאו (Bang Tao Beach)',
          text: 'חוף ארוך ושקט עם מתחם ריזורטים מפוארים (Laguna Phuket) הכולל גם מסלול גולף, ספא מפנק ומסעדות איכותיות. מושלם לחופשת בטן - גב ברמה גבוהה למשפחות, זוגות ומטיילים המחפשים שקט.',
        },
        {
          subtitle: 'נאי הארן (Nai Harn Beach)',
          text: 'חוף קטן ואינטימי בדרום האי, מוקף בגבעות ירוקות ולגונות טבעיות. המקום אידיאלי לחובבי טבע, שחייה ושיזוף שרוצים להתרחק מהמוני התיירים.',
        },
        {
          subtitle: 'נאי תון ונאי יאנג (Nai Thon & Nai Yang Beaches)',
          text: 'חופים שקטים בצפון האי, קרובים לשדה התעופה. מתאימים במיוחד לחופשות רגועות, לזוגות שמחפשים שקט או למחפשים לינה נוחה לפני טיסות.',
        },
      ],
    },
    {
      title: 'חופים נוספים בפוקט, ללא לינה',
      type: 'sub-headers',
      content: [
        {
          subtitle: 'חוף פרדייז (Paradise Beach)',
          text: 'חוף קטן, ציורי ותוסס ולטעמינו, החוף היפה ביותר בפוקט, הנמצא במרחק קצר מפטונג. גישה נוחה (כולל שאטל מהקניון), בריכה חיצונית, מסיבות פולמון צבעוניות וחוויית חוף מהנה במיוחד.',
        },
        {
          subtitle: 'חוף פרידום (Freedom Beach)',
          text: 'פנינה מבודדת ואחת היפות בפוקט, אליה ניתן להגיע רק בשייט קצר בסירה. החול הלבן והמים הצלולים יוצרים תפאורה מושלמת לרגעים של שקט ושלווה.',
        },
      ],
    },
    {
      title: 'תחבורה ציבורית בפוקט',
      type: 'sub-headers',
      content: [
        {
          subtitle: 'מוניות',
          text: 'זמינות כמעט בכל מקום ולאורך כל שעות היממה, אך מחירן יקר ביחס לשאר תאילנד. מומלץ להתמקח על המחיר מראש או להשתמש באפליקציות כמו Bolt או Grab להזמנות במחיר קבוע.',
        },
        {
          subtitle: 'טוק - טוקים',
          text: 'כלי תחבורה צבעוניים ומזוהים עם פוקט. נסיעה קצרה יכולה להיות חוויה נחמדה, אך חשוב לסגור מחיר לפני העלייה לטוק - טוק.',
        },
        {
          subtitle: 'אוטובוסים מקומיים ("סונגתאו")',
          text: 'משאיות קטנות עם ספסלים מאחור המציעות תחבורה זולה בין העיירות המרכזיות כמו פטונג, קארון, קאטה ופוקט טאון. חוויה אותנטית מאוד למעוניינים לטייל כמו מקומיים.',
        },
        {
          subtitle: 'שכירת רכב או קטנוע',
          text: 'אופציה פופולרית ומומלצת מאוד, מאפשרת חופש מלא לטייל ברחבי האי. חשוב להצטייד ברישיון נהיגה בינלאומי ובביטוח מתאים, ולהיזהר בנהיגה (בפוקט נוסעים בצד שמאל של הכביש).',
        },
        {
          subtitle: 'שאטלים פרטיים',
          text: 'מלונות רבים מציעים שירותי הסעות פרטיות מ/ אל נמל התעופה ואל מרכזי הקניות/ חופים פופולריים – אופציה נוחה למשפחות וקבוצות.',
        },
      ],
    },
    {
      title: 'דרכי הגעה לפוקט ונמל התעופה',
      type: 'sub-headers',
      content: [
        {
          subtitle: 'הגעה בטיסה',
          text: 'הדרך הנפוצה והנוחה ביותר להגיע לפוקט הינה בטיסה. נמל התעופה הבינלאומי של פוקט (Phuket International Airport – HKT) ממוקם בצפון האי ומקבל טיסות ישירות מרחבי העולם, כולל טיסות עונתיות ישירות מישראל. ישנן אף טיסות פנימיות רבות מבנגקוק, צ׳אנג מאי, קראבי, קו סמוי ועוד – זמינות ונוחות.',
        },
        {
          subtitle: 'מעבר יבשתי',
          text: 'ניתן להגיע ברכב או אוטובוס מהיבשת לפוקט דרך שני גשרים – גשר Sarasin וגשר Thepkasattri, המחברים את האי לחלקה הדרומי של תאילנד.',
        },
        {
          subtitle: 'הגעה בסירה',
          text: 'חלק מהמטיילים משלבים את פוקט כחלק מטיול בין איים ומגיעים בסירות מהאיים הקרובים כמו קופיפי, קראבי וקו יאו יאי.',
        },
      ],
    },
    {
      title: 'אטרקציות מרכזיות בפוקט',
      description:
        'פוקט מציעה עשרות אתרי טבע, תרבות, חוויות אקסטרים ואטרקציות מיוחדות. הנה הרשימה שלא תרצו לפספס:',
      type: 'sub-headers',
      content: [
        {
          subtitle: 'ביג בודהה (Big Buddha)',
          text: 'פסל עצום בגובה 45 מטרים הממוקם על גבעה גבוהה ומשקיף על כל האי. האווירה במקום שלווה ומרשימה והתצפית עוצרת נשימה – במיוחד בשעת השקיעה.',
        },
        {
          subtitle: 'מקדש ואט צ׳אלונג (Wat Chalong)',
          text: 'המקדש הבודהיסטי החשוב ביותר בפוקט, המהווה מרכז רוחני ותרבותי לתושבים ולמבקרים. המבנים המעוטרים והאווירה השלווה מספקים הצצה אל תוך המסורת התאילנדית.',
        },
        {
          subtitle: 'נקודת התצפית פרומטפ קייפ (Promthep Cape)',
          text: 'אחת מנקודות השקיעה הפופולריות ביותר באי. גבעה קסומה עם נוף פתוח אל ים אנדמן – מקום מושלם לטיול רומנטי בשעת ערב.',
        },
        {
          subtitle: 'שייט לאי ג׳יימס בונד (James Bond Island)',
          text: 'שייט קסום במפרץ פאנג-נגה (מוכר כטיול יום ארבעת האיים), בין סלעים וצוקים מרהיבים, עד להגעה לאי המפורסם שהופיע בסרט "האיש בעל אקדח הזהב". חוויית קיאקים במערות וטבע פראי מובטחת.',
        },
        {
          subtitle: 'שייט לאיי פי פי (Phi Phi Islands)',
          text: 'אחד היעדים היפים והאייקוניים בתאילנד. חופים לבנים, מים בצבע טורקיז ותמונות נוף שנראות כאילו יצאו מתוך גלויה. מתאים לטיולי יום (מוכר כטיול יום שבעת האיים) או ללינה באי.',
        },
        {
          subtitle: 'איי סימילאן ואיי סורין (Similan & Surin Islands)',
          text: 'שמורות טבע ימית מהיפות בעולם, המציעות חוויות צלילה ושנורקלינג מדהימות בין שוניות אלמוגים ודגים צבעוניים. נגישות באמצעות הפלגות יומיות מפוקט, בעונה בלבד (מאי – אוקטובר).',
        },
        {
          subtitle: 'חוות פילים שיקומיות (Elephant Sanctuaries)',
          text: 'חוות טיפול ושיקום לפילים, המאפשרות מפגש קרוב ומרגש עם הפילים – ללא רכיבה, אלא תוך שמירה על זכויותיהם. חוויה מרגשת ואותנטית.',
        },
        {
          subtitle: 'פארק המים אנדמנדה (Andamanda Water Park)',
          text: 'פארק מים חדשני ומושקע עם מגוון מגלשות, בריכות ענק, אזורים למשפחות ומתחמי VIP. מקום מצוין ליום כיף מרענן תחת השמש של פוקט.',
        },
        {
          subtitle: 'אומגות וטרקטורונים בג׳ונגל',
          text: 'חוויות אקסטרים בג׳ונגלים הירוקים של פוקט, אדרנלין בלב הטבע – כולל גלישות בין צמרות עצים ונסיעה בשבילי עפר והרפתקאות. מוצעים כטיולים של חצי יום וברמות שונות, חווייה מומלצת מאוד.',
        },
        {
          subtitle: 'האקווריום (Aquaria)',
          text: 'עולם הים בקניון Central Phuket. מקום ענק עם אולמות תצוגה רבים המציגים סוגים רבים של בעלי חיים ימיים, לרבות כרישים, כלבי ים, מדוזות ועוד. מומלץ מאוד עבור משפחות עם ילדים קטנים ומהווה אף בילוי מהנה עבור ימים גשומים. ניתן לשלב ביקור במוזיאון הטריקים המצוי אף הוא באותו מקום.',
        },
      ],
    },
    {
      title: 'מופעי ערב בפוקט – חגיגה של צבע, תרבות ובידור',
      type: 'sub-headers',
      content: [
        {
          text: 'פוקט אינה נרדמת עם רדת הערב – להיפך, האי מתעורר לחיים עם שפע של מופעי ערב מרהיבים המתאימים לכל גיל ולכל טעם. מהמופעים התרבותיים המושקעים ביותר, דרך מופעי קרנבל נוצצים ועד מופעי דראג עליזים ומרהיבים – כל ערב בפוקט יכול להפוך לחגיגה בלתי נשכחת. מופעי הערב של האי מצטיינים בהפקות מושקעות, תפאורות עשירות, תלבושות ססגוניות ואפקטים מרהיבים, ומציעים חוויית בילוי מהנה במיוחד המוסיפה צבע ואנרגיה לכל חופשה.',
        },
        {
          subtitle: 'סיימון קברט (Simon Cabaret)',
          text: 'אחד המופעים המפורסמים והוותיקים בפוקט, המציע חוויה של צבע, זוהר ואנרגיה מתפרצת. מדובר במופע דראג קברטי איכותי, עם תלבושות מפוארות, תפאורות ססגוניות וביצועים מרשימים של להיטי פופ בינלאומיים לצד שירים מקומיים. השחקנים המקצועיים — גברים בלבוש נשי מרהיב — מציגים הופעה מלאת הומור, כישרון ותיאטרליות. המופע מתאים לכל הגילאים ומהווה חוויה בלתי נשכחת למבקרים בפוקט.',
        },
        {
          subtitle: 'פנטסי פוקט (Phuket FantaSea)',
          text: 'פארק תרבותי עצום המשלב מופע ערב מרהיב עם בילוי לכל המשפחה. המופע המרכזי משלב אלמנטים של מסורת תאילנדית, ריקודים, אקרובטיקה, אפקטים מיוחדים ובעלי חיים ובכלל זה, פילים אמיתיים. התפאורות מרהיבות, האולם ענקי ומעוצב כארמון תאילנדי קסום ובכניסה מחכה לכם כפר בידור עם דוכנים, משחקים, מופעי רחוב ומסעדת ענק לארוחת ערב בסגנון בופה. מופע מושקע במיוחד המציע הצצה מרתקת לתרבות ולמיתולוגיה התאילנדית.',
        },
        {
          subtitle: 'סיאם נירמיט (Siam Niramit Phuket)',
          text: 'מופע תרבותי מרהיב החוגג את ההיסטוריה והמסורת של תאילנד, עם עשרות שחקנים, תלבושות מושקעות, ריקודים אותנטיים ותפאורות דינמיות. ההפקה מביאה את סיפוריה של תאילנד לאורך הדורות - החל מהתקופות הקדומות ועד לעידן המודרני ומשלבת אפקטים מרהיבים כמו נהרות על הבמה ופעלולי אורות מרשימים. חוויית חובה לחובבי תרבות ואומנות המעוניינים להבין טוב יותר את שורשיה העשירים של תאילנד.',
        },
        {
          subtitle: 'קרניבל מג׳יק (Carnival Magic)',
          text: 'אחד המופעים החדשים והמרהיבים בפוקט, המשלב פארק נושא צבעוני עם מופע ערב עוצר נשימה. החוויה מתחילה בטיול בכפר צבעוני מואר באלפי אורות, דוכנים ומיצגים מרהיבים וממשיכה במופע "רויאל גאלה" – מופע ססגוני עם עשרות משתתפים, תחפושות מפוארות, קרונות ענקיים כמו בקרנבל אמיתי ואפקטים מיוחדים. זהו מופע המזכיר את הקרנבלים הגדולים של ריו דה ז\'ניירו – גרסה תאילנדית עשירה ומרהיבה במיוחד. מתאים לכל המשפחה.',
        },
        {
          subtitle: 'מופעי איגרוף תאילנדי (Muay Thai Shows)',
          text: 'בפוקט תוכלו לצפות גם במופעי איגרוף תאילנדי – הספורט הלאומי של תאילנד – באולמות מקצועיים כמו Patong Boxing Stadium. המופעים כוללים קרבות אמיתיים, לצד מופעי הדגמה של טכניקות מסורתיות. זוהי חוויה אותנטית ומלהיבה לחובבי ספורט ותרבות מקומית.',
        },
        {
          subtitle: 'מופעי קסמים והומור',
          text: 'בפוקט קיימים גם מופעים קטנים יותר של קוסמים, ליצנים ואומני בידור המיועדים לכל המשפחה, כמו ה-Magic Carnival Show בתוך מתחם Carnival Magic, או מופעים בבתי מלון ואזורים תיירותיים בפטונג.',
        },
      ],
    },
    {
      title: 'איזו חוויה לבחור? המלצות לפי סוג מטיילים',
      type: 'sub-headers',
      content: [
        {
          subtitle: 'למשפחות עם ילדים',
          text: '"פנטסי פוקט" ו"קרניבל מג\'יק" הינם בחירה מושלמת. הם מציעים מופעים ססגוניים, תפאורות מרהיבות, חיות, צבעים ואפקטים שירתקו גם את הילדים וגם את המבוגרים.',
        },
        {
          subtitle: 'לזוגות רומנטיים',
          text: 'מופע "סיימון קברט" מספק ערב בלתי נשכח של בידור קליל וצבעוני. אפשר לשלב את המופע עם בילוי מוקדם במסעדה או בר באזור פטונג. לחילופין, מופע "סיאם נירמיט" ייקח אתכם למסע תרבותי קסום ומרשים.',
        },
        {
          subtitle: 'לחובבי תרבות והיסטוריה',
          text: '"סיאם נירמיט" הינו מופע חובה. עם תפאורות מושקעות, מוזיקה חיה וסיפורים היסטוריים, זוהי חוויה מעשירה המביאה את סיפורה של תאילנד לחיים האמיתיים.',
        },
        {
          subtitle: 'לחובבי אקשן וספורט',
          text: 'מופעי איגרוף תאילנדי הם הבחירה הנכונה – חווית צפייה מרתקת באווירה ספורטיבית אמיתית, המשלבת מסורת, אנרגיה גבוהה ואותנטיות.',
        },
        {
          subtitle: 'למחפשים חוויה מיוחדת ושונה',
          text: '"קרניבל מג\'יק" הוא מקום שפשוט אי אפשר להישאר אדישים אליו – קרנבל צבעוני ועוצר נשימה המרגיש כמו חוויית דיסני בתאילנד.',
        },
      ],
    },

    {
      title: 'טיפים לבחירת מופע ערב בפוקט',
      type: 'sub-headers',
      content: [
        {
          subtitle: 'התאימו את סוג המופע לקהל היעד',
          text: "משפחות עם ילדים ייהנו יותר ממופעים כמו פנטסי פוקט או קרניבל מג'יק, בעוד שמופעי דראג כמו סיימון קברט מתאימים יותר למבוגרים.",
        },
        {
          subtitle: 'הזמינו כרטיסים מראש',
          text: 'בעונות השיא (נובמבר – אפריל) המופעים מתמלאים במהירות. הזמנה מוקדמת תבטיח מקומות טובים ולעיתים אף מחירים מוזלים.',
        },
        {
          subtitle: 'בדקו את זמני מופע ושירותי הסעה',
          text: 'מופעים רבים מציעים שירות הסעה מהמלון וחזרה. מומלץ לבדוק זאת בעת ההזמנה.',
        },
        {
          subtitle: 'הקדישו זמן לביקור באתר עצמו',
          text: "מתחמים כמו פנטסי פוקט וקרניבל מג'יק כוללים גם מתחמי קניות ואטרקציות נוספות שכדאי ליהנות מהם לפני תחילת המופע.",
        },
        {
          subtitle: 'בדקו אפשרויות כיבוד וארוחות',
          text: 'בחלק מהמופעים ניתן לשלב גם ארוחת ערב חגיגית כחלק מהחבילה.',
        },
        {
          subtitle: '',
          text: 'לסיכום, פוקט מציעה שלל מופעי ערב מרהיבים המעשירים כל חופשה בחוויה בלתי נשכחת – מאולמות מפוארים עם מופעים תרבותיים, דרך מופעי דראג צבעוניים ועד לאירועי קרנבל ססגוניים ומופעי איגרוף מסורתיים.<br/>בין אם הינכם מחפשים ערב של תרבות והיסטוריה, בילוי משפחתי תוסס, או חוויה ספורטיבית אותנטית – בפוקט תמצאו מופע שיתאים בדיוק למה שהינכם מחפשים. מומלץ להזמין כרטיסים מראש בעונת התיירות ולהבטיח מקומות טובים. חוויית מופעי הערב בפוקט הינה בהחלט אחת מהחוויות שמותירות רושם עמוק ויוצאות דופן בכל ביקור באי.',
        },
      ],
    },
    {
      title: 'מוזיאונים ואתרי תרבות בפוקט',
      type: 'sub-headers',
      content: [
        {
          text: 'לצד החופים והשווקים, פוקט מציעה גם מפגש עם האמנות, ההיסטוריה והתרבות המקומית. הכירו את המוזיאונים המובילים באי.',
        },
        {
          subtitle: 'מוזיאון הטריקים (Phuket Trickeye Museum)',
          text: 'מוזיאון אינטראקטיבי עם תמונות תלת-ממדיות המאפשרות למבקרים להיכנס לתוך סצנות ולהיות חלק מהן. חוויה משפחתית כיפית עם הרבה צילום ויצירתיות.',
        },
        {
          subtitle: 'מוזיאון פוקט טאון (Phuket Town Museum)',
          text: 'מוזיאון קטן ומעניין המציג את ההיסטוריה של האי, כולל תצוגות על התרבות המקומית, המורשת והסחר שהיה כאן בעבר. ממוקם במרכז פוקט טאון.',
        },
        {
          subtitle: 'מוזיאון הצעצועים (Phuket Toy Museum)',
          text: 'מוזיאון ייחודי, בו תוכלו למצוא מגוון צעצועים מכל רחבי העולם, מימי הילדות ועד היום. זהו מקום נהדר למחפשים מקום יצירתי למבקרים בכלל הגילאים.',
        },
        {
          subtitle: 'מוזיאון הבית ההפוך (The Upside Down House Museum)',
          text: 'מבנה הפוף בן 3 קומות (עומד על הגג) בפוקט טאון. כל מוצגי הבית אמנם הפוכים אך, בפועל, נמצאים במקומם ולמעשה, המבקרים הם אלה ההפוכים. מהווה בילוי נחמד ליום גשום.‬‬',
        },
      ],
    },
    {
      title: 'שווקים וקניונים בפוקט',
      type: 'sub-headers',
      content: [
        {
          subtitle: 'שוק הלילה של יום ראשון (Sunday Night Market)',
          text: 'שוק רחוב אותנטי ומיוחד, המתקיים מדי שבוע בימי ראשון בפוקט טאון – מספר 1 באי! מלא בעבודות יד, אוכל מקומי, בגדים, תכשיטים, הופעות של להקות מקומיות ועוד. מקום מעולה לחוות את האווירה המקומית.',
        },
        {
          subtitle: 'שוק נאקה (Naka Market)',
          text: 'שוק לילה ענק, בפוקט טאון, פעיל בסופ"שים (שבת וראשון), בו ניתן למצוא אוכל מקומי, בגדים, אביזרי טלוויזיה ואלקטרוניקה. מקום מצוין לחוויית קניות אותנטית, למוצרים מקוריים ומזוייפים.',
        },
        {
          subtitle: 'שוק Chillva',
          text: 'שוק צעיר ומדליק בעיצוב קונטיינרים, בפוקט טאון, פעיל בימים שני עד שבת ומהווה מוקד בילוי עבור הצעירים המקומיים. בסופ"שים, מתווסף אליו שוק פשפשים נחמד.',
        },
        {
          subtitle: 'קניון Central Phuket',
          text: 'מרכז קניות מודרני וענק בפוקט טאון, הכולל חנויות מותגים, מסעדות, אטרקציות לילדים ואזורי בידור. חלק נוסף של הקניון מהווה מוקד בילוי קבוע ומכיל אקווריום ענק, מוזיאון הטריקים, שוק צף קטן ובתי קולנוע משוכללים. אידיאלי לימים גשומים ולמחפשים חוויית קניות יוקרתית באי.',
        },
        {
          subtitle: 'קניון Jungceylon',
          text: 'אחד הקניונים הגדולים ביותר בפוקט, ממוקם בפטונג. כולל חנויות מותגים בינלאומיים, מסעדות, ובתי קפה, יחד עם מרכז בידור המכיל קולנוע, משחקי וידאו ומתחם בידור משפחתי.',
        },
        {
          subtitle: 'שוק פרנדלי (Phuket Friendly Market)',
          text: 'שוק נוסף בקארון, בו תמצאו בגדים, צעצועים, תכשיטים ואוכל מקומי. מקום טוב אם הינכם מעוניינים להרגיש את פוקט האמיתית והפשוטה יותר.',
        },
      ],
    },
    {
      title: 'חוויות קולינריות בפוקט',
      type: 'sub-headers',
      content: [
        {
          text: 'פוקט הינה חגיגה אמיתית לאוהבי אוכל – ממסעדות שוק ועד מסעדות גורמה על חוף הים. היא מלאה במסעדות המגישות את מיטב המאכלים התאילנדיים האותנטיים. תוכלו לטעום פה דגים טריים, סושי, סאטי, פאד תאי, קארי תאילנדי ועוד. לא לפספס את החוויות הקולינריות ברחוב פטונג וברחוב קארון. הנה המקומות והטעמים שאסור לכם לפספס:',
        },
        {
          subtitle: 'שווקי אוכל',
          text: 'שווקי האוכל המקומיים בפוקט מציעים מגוון רחב של מנות רחוב טעימות – כמו פירות טרופיים, סלט פאפאיה, דים סאם ומאכלי ים טריים. השוק הלילי של יום ראשון בפוקט טאון הינו מקום מעולה לטעום את כל המנות המקומיות.',
        },
        {
          subtitle: 'מסעדות יוקרה',
          text: 'אם הינכם מחפשים חוויה קולינרית יוקרתית, ישנם מסעדות ברמה גבוהה עם נופים מרהיבים של הים והחופים. מסעדות כמו "Mom Tri\'s Kitchen", "Siam Supper Club", "Blue Elephant", "Suay" המציעות אוכל מצויין לצד אווירה בלתי נשכחת.',
        },
        {
          subtitle: 'ברים וברים על הגג',
          text: 'פוקט מציעה ברים אופנתיים עם נופים מדהימים של האוקיינוס, למשל "Baba Nest" במלון Sri Panwa. מומלץ לשתות קוקטיילים למול הנוף המרהיב של החופים.',
        },
      ],
    },
    {
      title: 'חיי לילה בפוקט',
      description:
        'כששוקעת השמש, פוקט מתעוררת לחיים: ברים, מועדונים, מופעים ומסיבות עד אור הבוקר. גלו את מוקדי חיי הלילה הכי לוהטים.',
      type: 'sub-headers',
      content: [
        {
          subtitle: 'פטונג',
          text: 'מרכז חיי הלילה של האי - פטונג הינו אזור חיי הלילה הפופולרי ביותר בפוקט, עם רחוב ה -  Bangla  המלא בברים, מועדונים, מופעי קברט ופעילויות ליליות מרהיבות. לא חסר אקשן, מוזיקה ותחושת מסיבה כל ערב.',
        },
        {
          subtitle: 'מועדוני לילה ומופעי קברט',
          text: 'פוקט מציעה מגוון מועדונים ומופעים כמו "Simon Cabaret" ו-"FantaSea" שבהם תוכלו ליהנות ממופעים מיוחדים, ריקודים וצבעים. אם הינכם אוהבים חיי לילה סוערים, מועדוני הלילה של פטונג כמו "Illuzion" ו-"Seduction" לא יאכזבו כלל וכלל.',
        },
        {
          subtitle: '',
          text: 'תרצו לשלב טעמים עם חיי לילה? סיורי אוכל וברים הם הדרך הכי מהנה להכיר את פוקט אחרי רדת החשכה:',
        },
        {
          subtitle: 'ברים עם נוף',
          text: 'אם הינכם מחפשים חוויה שקטה יותר עם קוקטיילים על רקע הנוף, ישנם לא מעט ברים על הגג המציעים את הנופים היפים ביותר של האי. כדאי לבקר ב-"Baba Nest"  שבמלון Sri Panwa, ב - The Kee Sky Lounge שבפטונג וב-"Kata Rocks" ליהנות מהשקיעה על כוס קוקטייל.',
        },
        {
          subtitle: 'ברים על החוף',
          text: 'כמו Catch Beach Club בסורין וקפה דל מאר בבנג טאו, יהוו בילוי מהנה ביותר החל מכשעה טרם השקיעה ולתוך הלילה.',
        },
      ],
    },

    {
      title: 'טיפים חשובים למטיילים בפוקט',
      description:
        'בטרם תארזו מזוודות – הנה כמה טיפים חיוניים שיעזרו לכם ליהנות מכל רגע ולחסוך לא מעט זמן וכסף במהלך החופשה:',
      type: 'sub-headers',
      content: [
        {
          subtitle: 'תחבורה פנימית',
          text: 'נהגי מוניות וטוק-טוקים עלולים לדרוש מחירים גבוהים – תמיד להתעקש על קביעת מחירים מראש ולוודא כי המחיר הוגן. ניתן ואף מומלץ ביותר לשכור אופנועים או רכבים פרטיים על מנת להתנייד בקלות באי.',
        },
        {
          subtitle: 'זהירות ממזג האוויר',
          text: 'פוקט חמה וטרופית והעונה הרטובה נמשכת בין מאי לנובמבר. מומלץ להביא בגדים קלים, כובעים, קרם הגנה ושתייה מרובה.',
        },
        {
          subtitle: 'כסף ומטבע',
          text: `המטבע המקומי בתאילנד הינו ה - "באט" (THB), ניתן להחליף כסף בצ'יינג'ים הפזורים בכל קרן זווית ובסניפי בנקים. ברוב בתי המלון, הקניונים והמסעדות, מתקבלים אף כרטיסי אשראי, אם כי בחלק מהמקומות מתווספת לתשלום העמלה של חברת האשראי (3%).`,
        },
        {
          subtitle: 'שמירה על סביבה בטוחה',
          text: 'פוקט נחשבת לאי יחסית בטוח, אך תמיד יש לשמור על הציוד האישי ולא להשאיר חפצים יקרי ערך ללא השגחה, במיוחד בחופים ובאזורי תיירות פופולריים.',
        },
        {
          subtitle: 'אוכל ושתייה',
          text: 'במידה ואינכם רגילים לאוכל עם תיבול חזק, מומלץ לבדוק עם המלצר את רמת החריפות של המנות כדי להימנע מהפתעות לא נעימות.',
        },
        {
          subtitle: 'ביטוח נסיעות',
          text: 'חובה, במיוחד אם הינכם שוכרים אופנוע. רשיון נהיגה לאופנוע, חובה אף הוא. בלעדיו, הביטוח אינו תקף. זכרו כי הנהיגה בתאילנד הינה בצד שמאל.',
        },
      ],
    },
    {
      title: 'סיכום',
      type: 'text',
      content:
        '<strong>פוקט מציע עולם ומלואו – חוויות מרתקות, נופים מהפנטים וטעמים בלתי נשכחים.</strong><br/>פוקט הינו אי שאין דומה לו ומהווה יעד מושלם לחופשה, הכוללת נופים עוצרי נשימה, תרבות עשירה, חופים חלומיים, טבע מרהיב, אטרקציות בלתי נגמרות ואווירה קסומה. בין אם זו חופשתכם הראשונה בתאילנד ובין אם הינכם חוזרים שוב — זהו אי שניתן ומומלץ לחזור אליו שוב ושוב ובכל ביקור לגלות בו עוד ועוד ולהתרגש מחדש.',
    },
  ],
};
